import { render, staticRenderFns } from "./AdminArticles.vue?vue&type=template&id=bb7c453e&scoped=true"
import script from "./AdminArticles.vue?vue&type=script&lang=js"
export * from "./AdminArticles.vue?vue&type=script&lang=js"
import style0 from "./AdminArticles.vue?vue&type=style&index=0&id=bb7c453e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7c453e",
  null
  
)

export default component.exports